import React, { useState } from 'react'
import context from '@/context'
import { Button } from '@/components/button'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import Resx from '@/components/Resx'
import { CbiAvailableBlacklists } from '@/components/demographics/cbiAvailableBlacklists'
import { CbiIgnoredBlacklists } from '@/components/demographics/cbiIgnoredBlacklists'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { IndividualPermissionProvider } from '../changeRequests/individualPermissionProvider'

export const CbiBlacklists = function ({ personId }) {
  const [showAvailable, setShowAvailable] = useState(true)

  return <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualBlacklists}>
    <div>
      <div className='btn-group'>
        <Button onClick={() => setShowAvailable(!showAvailable)} className='btn'>
          {showAvailable ? <Resx name='Individuals.DisplayIgnoredRecords' /> : <Resx name='Individuals.DisplayAvailableRecords' /> }
        </Button>
      |
        <Button className={'btn'} onClick={() => getStore().dispatch(dialogActions.openDialog({
          dialogType: dialogTypes.confirm,
          title: 'Individuals.SynchronizeBlacklistRecords',
          content: 'Individuals.SynchronizeBlacklistRecordsContent',
          onAction: () => context.api.blacklistRecordService.synchronizeCbiBlacklists()
        }))}>
          <Resx name='Individuals.SynchronizeFromCbi' />
        </Button>
      </div>
      <br />
      {showAvailable ? <CbiAvailableBlacklists personId={personId} /> : <CbiIgnoredBlacklists personId={personId} /> }
    </div>
  </IndividualPermissionProvider>
}



// WEBPACK FOOTER //
// ./src/components/demographics/cbiBlacklists.js